<template>
  <div class="service">
    <!-- 顶部标题栏 -->
    <div class="header">
      <div class="title">服务</div>
      <div class="custom-btn" @click="goCustomize">
        <svg viewBox="0 0 24 24" class="edit-icon"><path d="M3 17 L17 3 L21 7 L7 21 L3 21 Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>
        <span>定制</span>
      </div>
    </div>

    <!-- 搜索栏 -->
    <div class="search-wrap">
      <div class="search-input" @click="goSearch">
        <svg viewBox="0 0 24 24" class="search-icon"><circle cx="11" cy="11" r="7" fill="none" stroke="#999" stroke-width="2"/><path d="M16 16 L21 21" stroke="#999" stroke-width="2" stroke-linecap="round"/></svg>
        <span class="placeholder">请输入关键字搜索</span>
      </div>
    </div>

    <!-- 我的应用 -->
    <div class="section-label">我的应用</div>
    <div class="my-apps-grid" v-if="myApps.length > 0">
      <div class="my-app-item" v-for="(app, idx) in myApps" :key="idx" @click="handleAppClick(app)">
        <img :src="app.icon" class="app-icon" :alt="app.title" @click="handleAppClick(app)" />
        <span class="app-name" @click="handleAppClick(app)">{{ app.title }}</span>
      </div>
    </div>
    <div class="empty-tip" v-else>暂无应用，点击右上角定制添加</div>

    <!-- 分类标签 -->
    <div class="tabs">
      <div
        v-for="(tab, i) in tabs"
        :key="tab"
        :class="['tab', { active: activeTab === i }]"
        @click="scrollToGroup(i)"
      >{{ tab }}</div>
    </div>

    <!-- 服务列表 -->
    <div class="service-list">
      <div v-for="(group, idx) in serviceGroups" :key="group.name" class="service-group" :ref="'group-' + idx">
        <div class="group-title">{{ group.name }}</div>
        <template v-for="item in group.items">
          <div
            :key="item.title"
            class="service-item"
            @click="handleClick(item)"
          >
            <img :src="getIcon(item.icon)" class="item-icon" :alt="item.title" />
            <span class="item-title">{{ item.title }}</span>
            <span v-if="item.expand" class="item-expand" :class="{ expanded: expandedItems[item.title] }">
              <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="none" stroke="#c8c9cc" stroke-width="1.5"/><path d="M8 10 L12 14 L16 10" fill="none" stroke="#c8c9cc" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </span>
            <svg v-else viewBox="0 0 24 24" class="item-arrow"><path d="M9 6 L17 12 L9 18" fill="none" stroke="#c8c9cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
          <div
            v-for="child in (expandedItems[item.title] ? item.children : [])"
            :key="item.title + '-' + child.title"
            class="service-item child-item"
            @click="handleChildClick(child)"
          >
            <span class="child-dot"></span>
            <span class="item-title">{{ child.title }}</span>
            <svg viewBox="0 0 24 24" class="item-arrow"><path d="M9 6 L17 12 L9 18" fill="none" stroke="#c8c9cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
        </template>
      </div>
      <div class="footer-tip">到底啦！</div>
    </div>
  </div>
</template>

<script>
import serviceGroups from '@/data/services'
import { navigateWithLoading } from '@/utils/loading'
const iconContext = require.context('@/assets/icons', false, /\.png$/)
const icons = {}
iconContext.keys().forEach(key => {
  const name = key.replace(/^\.\//, '').replace(/\.png$/, '')
  icons[name] = iconContext(key)
})

export default {
  name: 'Service',
  data() {
    return {
      activeTab: 0,
      tabs: ['就业创业', '社会保险', '人才人事', '劳动关系', '社会保障卡'],
      serviceGroups,
      expandedItems: {},
      myApps: [
      { title: '个人权益记录查询打印', icon: icons['svc-rights-print'], path: '/rights-record-print' }
    ]
    }
  },
  created() {
    // 从 localStorage 恢复我的应用，如果没有则使用默认值
    const saved = localStorage.getItem('myApps')
    if (saved) {
      try {
        const parsed = JSON.parse(saved)
        if (parsed && parsed.length > 0) {
          // 迁移：本地存的图标是旧构建 hash URL，重建后会 404，按标题刷新为当前资源
          parsed.forEach(a => {
            const def = this.myApps.find(d => d.title === a.title)
            if (def) {
              a.icon = def.icon
              a.path = def.path
            } else {
              const found = this.findServiceByTitle(a.title)
              if (found) {
                a.icon = this.getIcon(found.icon)
                a.path = found.path || a.path
              }
            }
          })
          this.myApps = parsed
        }
      } catch (e) {
        // 解析失败时保持默认值
      }
    }
  },
  methods: {
    getIcon(name) {
      return icons[name] || ''
    },
    // 按标题在全部分类（含子项）中查找服务定义，用于恢复本地数据时刷新图标
    findServiceByTitle(title) {
      for (const group of serviceGroups) {
        for (const item of group.items) {
          if (item.title === title) return item
          if (item.children) {
            const child = item.children.find(c => c.title === title)
            if (child) return child
          }
        }
      }
      return null
    },
    handleClick(item) {
      if (item.expand) {
        this.$set(this.expandedItems, item.title, !this.expandedItems[item.title])
        return
      }
      if (item.path) {
        navigateWithLoading(item.path, 2000)
      } else {
        console.log('Clicked:', item.title)
      }
    },
    handleChildClick(child) {
      if (child.path) {
        navigateWithLoading(child.path, 2000)
      } else {
        console.log('Clicked child:', child.title)
      }
    },
    handleAppClick(app) {
      console.log('App clicked:', app)
      if (app.path) {
        navigateWithLoading(app.path, 2000)
      } else {
        console.log('No path for app:', app.title)
      }
    },
    goSearch() {
      navigateWithLoading('/search', 2000)
    },
    goCustomize() {
      navigateWithLoading('/service-customize', 2000)
    },
    scrollToGroup(idx) {
      this.activeTab = idx
      const groupEl = this.$refs['group-' + idx] && this.$refs['group-' + idx][0]
      if (groupEl) {
        const container = groupEl.closest('.page-container') || document.documentElement
        const tabsHeight = this.$el.querySelector('.tabs').offsetHeight
        const top = groupEl.getBoundingClientRect().top - container.getBoundingClientRect().top + container.scrollTop - tabsHeight
        container.scrollTo({ top, behavior: 'smooth' })
      }
    }
  }
}
</script>

<style scoped>
.service {
  background: #f5f5f5;
  min-height: 100%;
}
.header {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(112 * var(--w));
  background: #fff;
  border-bottom: 1px solid #ebebeb;
}
.title {
  font-size: calc(52 * var(--w));
  font-weight: 500;
  color: #323233;
}
.custom-btn {
  position: absolute;
  right: calc(56 * var(--w));
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: calc(8 * var(--w));
  font-size: calc(36 * var(--w));
  color: #ff976a;
}
.edit-icon {
  width: calc(40 * var(--w));
  height: calc(40 * var(--w));
}
.search-wrap {
  background: #fff;
  padding: calc(20 * var(--w)) calc(24 * var(--w)) calc(16 * var(--w));
}
.search-input {
  height: calc(72 * var(--w));
  background: #f2f2f2;
  border-radius: calc(36 * var(--w));
  display: flex;
  align-items: center;
  gap: calc(8 * var(--w));
  padding: 0 calc(24 * var(--w));
}
.search-icon {
  width: calc(36 * var(--w));
  height: calc(36 * var(--w));
  flex-shrink: 0;
}
.placeholder {
  font-size: calc(28 * var(--w));
  color: #c8c9cc;
}
.section-label {
  padding: calc(20 * var(--w)) calc(24 * var(--w));
  font-size: calc(50 * var(--w));
  color: #ff976a;
  border-left: calc(5 * var(--w)) solid #ff976a;
  margin-top: calc(16 * var(--w));
  background: #fff;
}
.my-apps-grid {
  display: flex;
  flex-wrap: wrap;
  padding: 0 calc(24 * var(--w));
  gap: calc(32 * var(--w));
  background: #fff;
  padding-bottom: calc(24 * var(--w));
}
.my-app-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: calc(180 * var(--w));
  cursor: pointer;
}
.app-icon {
  width: calc(96 * var(--w));
  height: calc(96 * var(--w));
  object-fit: contain;
}
.app-name {
  font-size: calc(28 * var(--w));
  color: #323233;
  margin-top: calc(8 * var(--w));
  text-align: center;
  width: calc(160 * var(--w));
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.3;
}
.empty-tip {
  padding: calc(20 * var(--w)) calc(24 * var(--w));
  font-size: calc(26 * var(--w));
  color: #999;
  background: #fff;
}
/* 分类标签：与下方内容的间距移到tab上方（与「我的应用」之间留白16w） */
.tabs {
  display: flex;
  background: #fff;
  overflow-x: auto;
  margin-top: calc(16 * var(--w));
  padding: 0 calc(24 * var(--w));
  gap: calc(32 * var(--w));
  height: calc(96 * var(--w));
  align-items: center;
  -webkit-overflow-scrolling: touch;
  position: sticky;
  top: 0;
  z-index: 10;
}
.tab {
  font-size: calc(50 * var(--w));
  color: #646566;
  white-space: nowrap;
  padding-bottom: calc(8 * var(--w));
  border-bottom: calc(3 * var(--w)) solid transparent;
  flex-shrink: 0;
}
.tab.active {
  color: #ff976a;
  font-weight: bold;
  border-bottom-color: #ff976a;
}
/* 服务列表：与tab的间距已移至tab上方，此处不留白 */
.service-list {
  margin-top: 0;
}
.service-group {
  margin-bottom: calc(16 * var(--w));
}
.group-title {
  padding: calc(20 * var(--w)) calc(24 * var(--w));
  font-size: calc(38 * var(--w));
  font-weight: bold;
  color: #323233;
  background: #fff;
  border-bottom: 1px solid #f5f5f5;
  border-left: calc(5 * var(--w)) solid #ff976a;
  padding-left: calc(19 * var(--w));
}
.service-item {
  display: flex;
  align-items: center;
  padding: calc(44 * var(--w)) calc(24 * var(--w));
  background: #fff;
  border-bottom: 1px solid #f5f5f5;
  gap: calc(20 * var(--w));
}
.item-icon {
  width: calc(64 * var(--w));
  height: calc(64 * var(--w));
  object-fit: contain;
  flex-shrink: 0;
}
.item-title {
  flex: 1;
  font-size: calc(46 * var(--w));
  color: #323233;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.item-arrow {
  width: calc(32 * var(--w));
  height: calc(32 * var(--w));
  flex-shrink: 0;
}
.item-expand {
  width: calc(40 * var(--w));
  height: calc(40 * var(--w));
  flex-shrink: 0;
  transition: transform 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
}
.item-expand svg {
  width: calc(40 * var(--w));
  height: calc(40 * var(--w));
}
.item-expand.expanded {
  transform: rotate(180deg);
}
.child-item {
  padding-left: calc(24 * var(--w));
  background: #fafafa;
}
.child-dot {
  width: calc(12 * var(--w));
  height: calc(12 * var(--w));
  border-radius: 50%;
  background: #07c160;
  flex-shrink: 0;
  margin-left: calc(20 * var(--w));
}
.child-item .item-title {
  font-size: calc(42 * var(--w));
  color: #646566;
}
.footer-tip {
  text-align: center;
  padding: calc(24 * var(--w)) 0 calc(32 * var(--w));
  font-size: calc(26 * var(--w));
  color: #c8c9cc;
}
</style>



// WEBPACK FOOTER //
// src/pages/Service.vue